// extracted by mini-css-extract-plugin
module.exports = {"table":"desktopDataLayout_table__2ir3A"};